var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nosotros"},[_c('NavBar',{on:{"updateSection":_vm.updateSection}}),_c('Portada'),_c('Cobertura',{attrs:{"id":"section_0"}}),_c('Mision',{attrs:{"id":"section_1"}}),_c('Evolucion',{attrs:{"id":"section_2"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }